export default "__VITE_ASSET__BGC4z2bb__"